import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkModeSubject = new BehaviorSubject<boolean>(false);
  public darkMode$: Observable<boolean> = this.darkModeSubject.asObservable();

  constructor() {
    this.initTheme();
  }

  /**
   * Inicializa el tema basado en localStorage
   */
  private initTheme(): void {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      this.enableDarkMode();
    } else {
      this.disableDarkMode();
    }
  }

  /**
   * Alterna entre modo oscuro y claro
   */
  toggleDarkMode(): void {
    if (this.darkModeSubject.value) {
      this.disableDarkMode();
    } else {
      this.enableDarkMode();
    }
  }

  /**
   * Activa el modo oscuro
   */
  enableDarkMode(): void {
    document.documentElement.setAttribute('data-theme', 'dark');
    localStorage.setItem('theme', 'dark');
    this.darkModeSubject.next(true);
  }

  /**
   * Desactiva el modo oscuro
   */
  disableDarkMode(): void {
    document.documentElement.removeAttribute('data-theme');
    localStorage.setItem('theme', 'light');
    this.darkModeSubject.next(false);
  }

  /**
   * Obtiene el estado actual del modo oscuro
   */
  get isDarkMode(): boolean {
    return this.darkModeSubject.value;
  }
} 